import { Injectable, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import { Proflie } from '../profile';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  baseUrl: string;
  category: Object;
  redirectUrl: string;
  user:Object;
  searchOption=[];
  public postsData: Proflie[];

  @Output() getLoggedInName: EventEmitter<any> = new EventEmitter();

  constructor(private _http: HttpClient,
    private platformLocation: PlatformLocation) { 
      // this.baseUrl = this.platformLocation['location'].origin;
      this.baseUrl = 'http://billyin.ca';
      // this.baseUrl = 'http://localhost/profile';
      // console.log(this.baseUrl);
    }

  public getIPAddress()  
  {  
    return this._http.get("http://api.ipify.org/?format=json");  
  }

  public userLogin(email: any, pwd: any) {
    return this._http.post<any>(this.baseUrl + '/server/login.php', { email, pwd })
    .pipe(map(Users => {
      this.setToken(Users[0].name);
      this.getLoggedInName.emit(true);
      this.user = Users;
      return Users;
    }));
  }
    
  public userRegistration(name,email,pwd,active,post_type) {
    return this._http.post<any>(this.baseUrl + '/server/register.php', { name,email, pwd, active,post_type })
    .pipe(map(Users => {
    return Users;
    }));
  }
    
  //token
  setToken(token: string) {
    localStorage.setItem('token', token);
  }
  getToken() {
    return localStorage.getItem('token');
  }
  deleteToken() {
    localStorage.removeItem('token');
  }
  isLoggedIn() {
    const usertoken = this.getToken();
    if (usertoken != null) {
      return true
    }
    return false;
  }

  getWebsites(category: any, number: any) {
    this.category = category != '' ? category: 'all';
    if(number != null) {
      return this._http.get<Proflie[]>(this.baseUrl + '/server/getItems.php?postType=websites&category=' + this.category + '&number=' + number);
    }else {
      return this._http.get<Proflie[]>(this.baseUrl + '/server/getItems.php?postType=websites&category=' + this.category);
    }    
  }

  getWebsiteDetail(url: any){
    return this._http.get<Proflie[]>(this.baseUrl + '/server/getItemDetail.php?postType=websites&url='+url);
  }

  getPhotos(category: any, number: any) {
    this.category = category != '' ? category: 'all';
    if(number != null) {
      return this._http.get<Proflie[]>(this.baseUrl + '/server/getItems.php?postType=photography&category=' + this.category + '&number=' + number);
    }else {
      return this._http.get<Proflie[]>(this.baseUrl + '/server/getItems.php?postType=photography&category=' + this.category);
    }    
  }

  getPhotoDetail(url: any){
    return this._http.get<Proflie[]>(this.baseUrl + '/server/getItemDetail.php?postType=photography&url='+url);
  }
  
  getUserDetail(id: any){
    return this._http.get<Proflie[]>(this.baseUrl + '/server/getItemDetail.php?postType=users&id='+id);
  }

  getMessage(number: any){
    return this.newMethod(number);
  }

  private newMethod(number: any) {
    if(number != 'all') {
      return this._http.get<Proflie[]>(this.baseUrl + '/server/getMessage.php?number=' + number);
    } else {
      return this._http.get<Proflie[]>(this.baseUrl + '/server/getMessage.php');
    }
  }

  getUsers(number: any) {
    if(number != 'all') {
      return this._http.get<Proflie[]>(this.baseUrl + '/server/getUsers.php?number=' + number);
    } else {
      return this._http.get<Proflie[]>(this.baseUrl + '/server/getUsers.php');
    }
  }

  updateItem(item: Proflie) {
    if(item.post_type == 'photography') {
      return this._http.put(this.baseUrl + '/server/updateItem.php?postType=photography&id=' + item.id, item);
    }
    if(item.post_type == 'website') {
      return this._http.put(this.baseUrl + '/server/updateItem.php?postType=websites&id=' + item.id, item);
    } else
    {
      return this._http.put(this.baseUrl + '/server/updateItem.php?postType=users&id=' + item.id, item);
    }
  }

  addItem(item: Proflie) {
    if(item.post_type == 'photography') {
      return this._http.post(this.baseUrl + '/server/addItem.php?postType=photography', item);
    } else {
      return this._http.post(this.baseUrl + '/server/addItem.php?postType=websites', item);
    }
  }

  deleteItem(item: Proflie) {
    console.log(item);
    console.log(item.id);
    console.log(item.post_type);
    if(item.post_type == 'photography') {
      return this._http.delete<Proflie[]>(this.baseUrl + '/server/deleteItem.php?postType=photography&id='+ item.id);
    } else if(item.post_type == 'website') {
      return this._http.delete<Proflie[]>(this.baseUrl + '/server/deleteItem.php?postType=websites&id='+ item.id);
    } else if(item.post_type == 'contacts') {
      return this._http.delete<Proflie[]>(this.baseUrl + '/server/deleteItem.php?postType=contacts&id='+ item.id);
    } else {
      return this._http.delete<Proflie[]>(this.baseUrl + '/server/deleteItem.php?postType=users&id='+ item.id);
    }
  }

  uploadImage(itemData: object, type: any,  thumbnail: any){
    return this._http.post(this.baseUrl + '/server/uploadImage.php?postType=' + type + '&thumbnail=' + thumbnail, itemData, {responseType: 'text'});
  }

  filteredListOptions() {
    let posts = this.postsData;
        let filteredPostsList = [];
        for (let post of posts) {
            for (let options of this.searchOption) {
                if (options.title === post.title) {
                  filteredPostsList.push(post);
                }
            }
        }
        console.log(filteredPostsList);
        return filteredPostsList;
  }

}
